import {Box, Button, Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {useContext} from "react";
import {IconExternalLink} from "@tabler/icons-react";
import {SignInContext} from "../../../context/SignInContext";
import {c, maxW} from "../landingTokens";

const NAV = [
  {label: "How it works", href: "#how"},
  {label: "Capabilities", href: "#capabilities"},
  {label: "Integrations", href: "#integrations"},
  {label: "Specs", href: "#specs"},
  {label: "FAQ", href: "#faq"},
];

const scrollToContact = () => {
  document.getElementById("contact")?.scrollIntoView({behavior: "smooth", block: "start"});
};

export const LandingHeader = () => {
  const {currentUser} = useContext(SignInContext);

  return (
    <Box
      component="header"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        bgcolor: "rgba(254,254,254,0.72)",
        backdropFilter: "saturate(180%) blur(20px)",
        borderBottom: `1px solid rgba(44,43,42,0.08)`,
      }}
    >
      <Stack
        component="nav"
        direction="row"
        alignItems="center"
        gap={{xs: 2, md: 4.25}}
        sx={{maxWidth: maxW, mx: "auto", height: 54, px: 2.75}}
      >
        <Typography component={Link} to="/" sx={{fontSize: 17, fontWeight: 600, letterSpacing: "-0.015em", color: c.ink, textDecoration: "none"}}>
          OpenBrain
        </Typography>

        <Stack direction="row" gap={3.25} sx={{flex: 1, display: {xs: "none", md: "flex"}}}>
          {NAV.map((item) => (
            <Typography
              key={item.href}
              component="a"
              href={item.href}
              sx={{fontSize: "12.5px", color: c.inkSoft, textDecoration: "none", "&:hover": {color: c.ink}}}
            >
              {item.label}
            </Typography>
          ))}
        </Stack>

        <Box sx={{flex: {xs: 1, md: "none"}}} />

        <Typography
          component="a"
          href="https://docs.openbrain.io"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: "12.5px",
            color: c.inkSoft,
            textDecoration: "none",
            display: {xs: "none", sm: "inline-flex"},
            alignItems: "center",
            gap: 0.5,
            "&:hover": {color: c.ink},
          }}
        >
          Docs
          <IconExternalLink size={13} stroke={1.75} />
        </Typography>

        <Typography
          component={Link}
          to={currentUser ? "/projects" : "/login"}
          sx={{fontSize: "12.5px", color: c.inkSoft, textDecoration: "none", display: {xs: "none", sm: "block"}, "&:hover": {color: c.ink}}}
        >
          {currentUser ? "My Projects" : "Sign in"}
        </Typography>

        <Button
          onClick={scrollToContact}
          variant="contained"
          sx={{
            bgcolor: c.ink,
            color: c.white,
            borderRadius: "980px",
            textTransform: "none",
            fontSize: "12.5px",
            fontWeight: 500,
            px: 2,
            py: 1,
            boxShadow: "none",
            "&:hover": {bgcolor: c.purpleDeep, boxShadow: "none"},
          }}
        >
          Get in touch
        </Button>
      </Stack>
    </Box>
  );
};
